<div class="ta-header">
  <pt-logo/>
  <div class="ta-header__right">
    <ta-header-user-profile/>
    <ta-header-controls/>
  </div>
</div>
